var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLockClosed = function SvgLockClosed(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 193,
    fill: "none",
    viewBox: "0 0 194 193",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M77.701 93.074V62.725a33.775 33.775 0 1 1 67.55 0v30.35c13.954 4.149 24.125 17.08 24.125 32.375v28.95a33.775 33.775 0 0 1-33.775 33.775h-48.25A33.775 33.775 0 0 1 53.576 154.4v-28.95a33.795 33.795 0 0 1 24.125-32.376m14.475-1.399v-28.95a19.3 19.3 0 0 1 38.6 0v28.95z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M72.875 120.625a19.298 19.298 0 0 0 32.947 13.647 19.296 19.296 0 0 0 0-27.294 19.297 19.297 0 0 0-27.294 0 19.3 19.3 0 0 0-5.653 13.647m28.95 0a9.653 9.653 0 0 1-9.65 9.65 9.653 9.653 0 0 1-9.65-9.65 9.65 9.65 0 0 1 9.65-9.65 9.653 9.653 0 0 1 9.65 9.65",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M116.3 72.375H68.05a33.775 33.775 0 0 0-33.775 33.775v28.95a33.777 33.777 0 0 0 33.775 33.775h48.25a33.775 33.775 0 0 0 33.775-33.775v-28.95A33.775 33.775 0 0 0 116.3 72.375M43.925 106.15A24.125 24.125 0 0 1 68.05 82.025h48.25a24.123 24.123 0 0 1 24.125 24.125v28.95a24.12 24.12 0 0 1-24.125 24.125H68.05A24.126 24.126 0 0 1 43.925 135.1z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M68.05 77.2a4.825 4.825 0 0 1-9.65 0V43.425a33.774 33.774 0 1 1 67.55 0V77.2a4.824 4.824 0 1 1-9.65 0V43.425A24.12 24.12 0 0 0 92.175 19.3 24.125 24.125 0 0 0 68.05 43.425z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLockClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/lock_closed.4117baefed98c30654bcdc3c579e0834.svg";